// extracted by mini-css-extract-plugin
module.exports = {"hidden":"apply_hidden__Ms08E","textEmphasis":"apply_textEmphasis__uWhRc","stickyArea":"apply_stickyArea__i4sfx","btnArea":"apply_btnArea__ChrM_"};